import React, { useRef } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilState, useRecoilCallback } from 'recoil'

import styled from '@emotion/styled'

import { Button, InputText, Select } from 'mailup-web-components'

import { modalBeeContentDialogSearchState } from '../recoil/state'
import { modalContentDialogSearchCallback } from '../recoil/callbacks'

const FormContainer = styled.div`
  margin-bottom: 20px;
`

const FormWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
`

const FormLabel = styled.div`
  display: block;
  font-size: 15px;
  margin-bottom: 5px;
  font-weight: 500;
  letter-spacing: 0.03em;
`

const InputSearchBy = styled(Select)`
  flex: 0 0 16.666667%;

  &.e-select {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
    background-color: var(--mercury);
  }

  .e-select__search {
    padding-top: 0;
    padding-bottom: 0;
  }

  .e-select__selected-item {
    color: var(--boulder);
  }
`

const InputSearchText = styled(InputText)`
  flex: 0 0 66.666667%;
  padding-right: 20px;

  &.e-input-text .e-input-text__input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`

const InputSubmitButton = styled(Button)`
  flex: 0 1 16.666666%;
  margin-left: 20px;
`

const SearchContentsForm = () => {
  const intl = useIntl()
  const [{ searchBy, searchText }, setSearchState] = useRecoilState(
    modalBeeContentDialogSearchState
  )

  const handleSearchByChange = value =>
    setSearchState(prev => ({ ...prev, searchBy: value }))

  const handleSearchTextChange = ({ target: { value } }) => {
    setSearchState(prev => ({ ...prev, searchText: value }))
  }

  const handleSearch = useRecoilCallback(modalContentDialogSearchCallback, [])

  const searchTextPlaceholder = intl.formatMessage(
    { id: 'Load.ContentsSourcesViewContents.SearchInFieldPlaceholder' },
    {
      field: searchBy
    }
  )

  const { current: searchByOptions } = useRef([
    {
      value: 'Title',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.Title'
      })
    },
    {
      value: 'ContentKey',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.ContentKey'
      })
    },
    {
      value: 'SubTitle',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.SubTitle'
      })
    },
    {
      value: 'Summary',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.Summary'
      })
    },
    {
      value: 'LinkText',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.LinkText'
      })
    },
    {
      value: 'LinkURL',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.LinkURL'
      })
    },
    {
      value: 'Author',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.Author'
      })
    },
    {
      value: 'Category',
      label: intl.formatMessage({
        id: 'Load.ContentsSourcesViewContents.Category'
      })
    }
  ])
  return (
    <FormContainer>
      <FormLabel>
        {intl.formatMessage({
          id: 'Load.BeeContentDialog.FilterResults'
        })}
      </FormLabel>

      <FormWrapper>
        <InputSearchBy
          value={searchBy}
          onChange={handleSearchByChange}
          options={searchByOptions}
          searchable={false}
        />

        <InputSearchText
          value={searchText}
          onChange={handleSearchTextChange}
          placeholder={searchTextPlaceholder}
        />

        <InputSubmitButton kind='secondary' onClick={handleSearch}>
          {intl.formatMessage({ id: 'Load.Common.Filter' })}
        </InputSubmitButton>
      </FormWrapper>
    </FormContainer>
  )
}

export default SearchContentsForm
